$(document).ready(function() {
    PageIsLoaded = true;
    if(typeof gdpr_delayed_function === 'function')
    {
        gdpr_delayed_function();
    }

});



$('#gdpr_accept_button, #gdpr_reject_button, .gdpr_opt_in_button').on('click', function () {
    var gdpr_notification_container = $('#gdpr_notification_container');
    setOptInCookie(gdpr_opt_in_cookie_name,'true',gdpr_opt_in_cookie_duration);

    if(checkCookiesForOptIn(gdpr_opt_in_cookie_name)) {
        $('body').removeClass("gdpr-shown"); //Only need to remove this class when a user clicks on the button because it shouldn't be added if they have already opted in
        gdpr_notification_container.fadeOut();
        /* For global header to move it back to the top */
        var global_header_top = $('.header_site').offset().top + 25;
        $('.global_header').css("top", "calc( "+global_header_top+"px * 1 / var(--recite-me-zoom) )");
        handlePolicyOptIn();
    } else {
        console.log("Warning: Did not hide notification because it was not actually accepted! Maybe cookies are disabled?");
    }
});

$('.gdpr_opt_out_button').on('click', function () {
    handlePolicyOptOut();
});



function setOptInCookie(name,value,days) {
    var expires = "";
    var domain = "";
    var host = window.location.host;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    //This will allow non-flinders domains to have the cookies saved, like localhost and dev/test author
    if(host.indexOf(".flinders.edu.au") > 1 ) {
        domain = "; domain=.flinders.edu.au";
    }
    document.cookie = name + "=" + (value || "")  + expires + domain +"; path=/";
}


//Attempt to delete all cookies!
function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++)
    {
        var split_cookie =  cookies[i].split("=");
        deleteCookieFromAllPaths(split_cookie[0]);
    }
}

//Note: does not delete cookies that are httpOnly, but does try to delete for variants of the path. (Note: most of our cookies have path "/" set.)
function deleteCookieFromAllPaths(name) {
    var split_path_array = location.pathname.split('/');
    var current_path = ' path=';
    document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';

    for (var i = 0; i < split_path_array.length; i++) {
        current_path += ((current_path.substr(-1) !== '/') ? '/' : '') + split_path_array[i];
        document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + current_path + ';';
    }
}

